// pages/layout/RedirectMCU2025.js
import { useEffect } from "react";

export default function RedirectMCU2025() {
  useEffect(() => {
    window.location.href = "https://befanetid-my.sharepoint.com/:x:/g/personal/diani_putri_befa_id/IQCKmoKpBDS4T7VIUE44q4aQAb01frZ4mOL8Pr5w8LVKrxE?e=0hDJ62";
  }, []);

  return null;
}